module.exports = __webpack_public_path__ + "static/media/bear_call_spread.3b3858e1.png";